import axios from 'axios'
import router from '@/router'
import StorageUtils from '@/utils/StorageUtils'
const DEFAULT_CONFIG = {
    baseURL: process.env.VUE_APP_API_BASE_URL,
    timeout: 15000
};

export default class Http {
    static createAxios(config = {}) {
        const headers = {headers: config.headers || {}};
        const auth_token = StorageUtils.getAuthToken();

        if (config) delete config.headers;

        if (auth_token) headers.headers.Authorization = `Bearer ${auth_token}`;
        const instance = axios.create( {...DEFAULT_CONFIG, ...headers, ...config});

        instance.interceptors.response.use( response => response,  error => {

            console.log(error.response);

            if (error && error.response && error.response.status === 401) {
                StorageUtils.destroyAuthToken();
                StorageUtils.destroyUser();
                router.push('/login');
            }

            return Promise.reject(error);
        });

        return instance;
    }

    static get(path, conf = {}) {
        return this.createAxios(conf).get(path);
    }

    static put(path, payload, conf = {}) {
        return this.createAxios(conf).put(path, payload);
    }

    static post(path, payload, conf = {}) {
        return this.createAxios(conf).post(path, payload);
    }

    static delete(path, conf = {}) {
        return this.createAxios(conf).delete(path);
    }

    static loadEntries = (path) => {
        return new Promise((resolve, reject) => {
            this.get(path)
                .then(({data}) => resolve(data))
                .catch(reject);
        })
    }
}
